/* RESPONSIBLE TEAM: team-data-foundations */
import ApplicationAdapter from 'embercom/adapters/application';

export default ApplicationAdapter.extend({
  buildURL(_modelName: string, id: string) {
    if (id) {
      return `teammate_app/standalone/data_sync/fields/${id}`;
    }
    return 'teammate_app/standalone/data_sync/fields';
  },
});
